<template>
  <div class="px-16">
    <c-label :color="$theme.COLOR.UI.UI13" :weight="500" :size="16" :lineHeight="16"
      >{{ $t('title.monitoringStatus') }}
    </c-label>
    <div class="content-wrapper">
      <div class="area">
        <ConfigTitle required class="title"
          >{{ $util.capitalize($t('label.widgetName')) }}
        </ConfigTitle>
        <lego-text-field
          ref="widgetName"
          :rules="validator.widgetName"
          :modelValue="widgetName"
          counter="100"
          showCounter
          :guide="$t('hint.common') + ' ' + $t('hint.notStartWithDot')"
          @update:modelValue="(value) => changeWidgetName(value)"
          isFreeText
        />
      </div>
      <BoxRegion class="area" />
    </div>
  </div>
</template>
<script>
import configMixin from './configMixin';
import validateFieldsMixin from '@/mixins/validateFields.mixin';

export default {
  props: ['configItem'],
  mixins: [configMixin, validateFieldsMixin],
  emits: ['update:changeField'],
  data() {
    return {
      isChanged: false,
      widgetName: '', // 위젯명
      defaultConfig: this.config({
        // 모니터링현황 위젯 기본정보
        title: this.$t('title.monitoringStatus'),
        w: 4,
        minW: 4,
        maxW: 4,
        widget: {
          type: 'MonitoringStatusWidget',
          api: '/cloudmonitorings/product/v1/console/metric-data',
          options: {}
        }
      }),
      validator: {
        widgetName: [this.checkWidgetName]
      },
      validateFieldKey: 'monitoringStatusWidgetConfig'
    };
  },
  watch: {
    changedFieldData: {
      handler(value) {
        this.$emit('update:changeField', value);
      },
      immediate: true
    }
  },
  mounted() {
    this.setFieldsBeforeModify();
  },
  methods: {
    validate() {
      return this.$util.validate([this.$refs.widgetName]);
    },
    onConfigChange(isApiCall = true) {
      let configs = [];
      let config = this.getCommonConfig();
      config.chartAttr.title = this.widgetName;
      config.isApiCall = isApiCall;
      configs.push(config);

      this.checkCount++;
      if (this.checkCount === 1) this.originConfigs = configs;

      this.$emit('configModify', configs);
    }
  }
};
</script>
<style lang="scss" scoped>
.title {
  margin-bottom: 6px;
}

.area {
  margin-bottom: 24px;
  display: flex;
  flex-direction: column;

  &:first-child {
    margin-bottom: 8px;
  }
}

.content-wrapper {
  margin-top: 24px;
}
</style>
